import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNavMaintenance({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M14.7 11.82l-3.2-3.2a2.03 2.03 0 00-2.33-.38L6.25 5.32v-1.7L2.75 1 1 2.75l2.63 3.5h1.7l2.9 2.91c-.36.76-.24 1.7.39 2.34l3.2 3.2c.4.4 1.05.4 1.44 0l1.44-1.44c.4-.4.4-1.04 0-1.44zm-4.63-4.67c.77 0 1.5.3 2.05.85l.53.53a3.87 3.87 0 002.23-4.54.33.33 0 00-.55-.15L12.3 5.87l-1.86-.3-.3-1.87 2.03-2.03a.33.33 0 00-.16-.55 3.94 3.94 0 00-3.73 1.03A3.87 3.87 0 007.15 5L9.4 7.23c.22-.05.45-.08.67-.08zM7.23 9.4L5.68 7.84l-4.17 4.17A1.75 1.75 0 104 14.5l3.38-3.38a2.94 2.94 0 01-.14-1.72zm-4.48 4.52a.65.65 0 11.66-.66c0 .36-.3.66-.66.66z" />
    </svg>
  );
}

SvgNavMaintenance.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNavMaintenance.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgNavMaintenance svgRef={ref} {...props} />);
export default ForwardRef;
